import { render, staticRenderFns } from "./RolePane.vue?vue&type=template&id=3801a4e8&scoped=true&"
import script from "./RolePane.vue?vue&type=script&lang=js&"
export * from "./RolePane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3801a4e8",
  null
  
)

export default component.exports